// @ts-expect-error - TS2614 - Module '"src/api-parsers/index"' has no exported member 'Workflow'. Did you mean to use 'import Workflow from "src/api-parsers/index"' instead?
import type {Workflow} from 'src/api-parsers/index';
// @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'Event'. Did you mean to use 'import Event from "src/api-parsers/events"' instead?
import type {Event} from 'src/api-parsers/events';


export function workflow(workflow: Workflow | string): string {
  const workflowId = typeof workflow === 'object' ? workflow.id : workflow;
  return `/journey/${workflowId}`;
}
export function analyticsWorkflow(workflow: Workflow | string): string {
  const workflowId = typeof workflow === 'object' ? workflow.id : workflow;
  return `/analytics/journey/${workflowId}`;
}

export function event(
  workflowObject: Workflow | string,
  event: Event | string,
  section?: string | null,
): string {
  const eventId = typeof event === 'object' ? event.id : event;
  let path = `${workflow(workflowObject)}/touchpoint/${eventId}`;
  if (section) {
    path = `${path}/${section}`;
  }
  return path;
}
